// Suivi des conversions LinkedIn (LinkedIn Insight Tag).
// Les ID de conversion proviennent de LinkedIn Campaign Manager.
export const LINKEDIN_CONVERSIONS = {
  whitepaper: 31033202,
};

export function trackLinkedInConversion(conversionId) {
  if (!conversionId) return;
  try {
    if (typeof window !== "undefined" && typeof window.lintrk === "function") {
      window.lintrk("track", { conversion_id: conversionId });
    }
  } catch {
    /* ignore */
  }
}
